<app-header-page>
    <h1>{{ 'HEADERS.USERS' | translate }}</h1>
</app-header-page>

<ng-template #inviteMemberView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.INVITE_MEMBER' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.MEMBER' | translate }}:</h2>
        <input #userMail aria-describedby="emailHelp" class="form-control" required>

        <h3>{{ 'MODALS.FIELDS.SELECT.PERMISSIONS.PERMISSION' | translate }}:</h3>
        <select #rights class="form-select" required>
            <option hidden value="">{{ 'MODALS.FIELDS.SELECT.PERMISSIONS.SELECT' | translate }}</option>
            <option value="inner"> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.INNER' | translate }}</option>
            <option value="outer"> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.OUTER' | translate }}</option>
            <option value="admin"> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.ADMIN' | translate }}</option>
        </select>
        <h2>{{ 'MODALS.FIELDS.POSITION' | translate }}:</h2>
        <input #comment aria-describedby="emailHelp" class="form-control">

        <button (click)="inviteUserInProject(userMail.value, rights.value, comment.value, modal)"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="addMemberInProjectButton"
                style="margin-top: 15px;"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<div class="content p-4">
    <button (click)="modalService.openTemplateModal(inviteMemberView)"
            class="btn btn-primary btn-sm"
            data-action="addMemberInProject"
    >
        <span>{{ 'USER_PROFILE.BUTTONS.INVITE' | translate }}</span>
    </button>
    <table class="table default-table table-tasks">
        <thead>
        <tr>
            <th></th>
            <th>{{ 'USER_PROFILE.TITLE.NAME' | translate }}</th>
            <th class="adaptiveTable">{{ 'USER_PROFILE.TITLE.POSITION' | translate }}</th>
            <th>{{ 'USER_PROFILE.TITLE.EMAIL' | translate }}</th>
            <th>{{ 'USER_PROFILE.TITLE.ROLE' | translate }}</th>
            <th>{{ 'USER_PROFILE.TITLE.EDS' | translate }}</th>
            <th class="col-small"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="!userList.length">
            <td colspan="8">
                <app-component-loading></app-component-loading>
            </td>
        </tr>
        <tr *ngFor="let user of userList; let i = index"
            [attr.data-member-index]="i"
        >
            <td class="stat__col">
                <span [class.active]="user.is_active"
                      class="stat__col__icon"
                >
                    {{ user.is_active ? '&#10004;' : '&#10006;' }}
                </span>
            </td>
            <td>
                <span (click)="helper.openProfileByGuid(user.guid)"
                      [class.blocked_user]="user.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!user.is_active"
                      class="user_profile"
                      data-action="openMemberProfile"
                >
                    <img *ngIf="user.project_setting.is_project_admin"
                         alt="#"
                         ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                         src="../../../../assets/images/admin.svg">
                    {{ helper.fullName(user) }}
                </span>
                <span (click)="helper.openProfileByGuid(user.guid)"
                      class="adaptiveInfo"
                      data-action="openMemberProfile"
                >
                    {{ 'USER_PROFILE.ROLE.ROLE' | translate }}
                    : {{ user ? ('USER_PROFILE.ROLE.' + user.project_setting.observation_type | translate) : '-' }}
                </span>
                <span (click)="helper.openProfileByGuid(user.guid)"
                      class="adaptiveInfo"
                      data-action="openMemberProfile"
                >
                    {{ 'USER_PROFILE.TEXT.POSITION' | translate }}: {{ user.position ? user.position : '-' }}
                </span>
            </td>
            <td class="adaptiveTable">
                {{ user.position ? user.position : '-' }}
            </td>
            <td>{{ user.email }}</td>
            <td>
                <app-component-button-more (answer)="updateProjectAdmin(user, $event)"
                                           (click)="checkRoles(user)"
                                           [bold]="true"
                                           [customization]="setCustomTop(i)"
                                           [hidden]="true"
                                           [variables]="signs"
                                           class="project_rights_setter"
                >
                    <span>
                        <i class="{{user.is_project_admin ? 'icon-down-1 text-danger' : 'icon-up-1 text-success'}}"></i>
                    </span>
                    {{ 'USER_PROFILE.ROLE.' + user.project_setting.observation_type | translate }}
                </app-component-button-more>
            </td>
            <td class="stat__col">
                <span [class.active]="user.has_crypto"
                      class="stat__col__icon"
                >
                    {{ user.has_crypto ? '&#10004;' : '&#10006;' }}
                </span>
            </td>
            <td class="small-col">
                <button [routerLink]="[user.guid]"
                        class="btn btn-light btn-sm"
                        data-action="openMember"
                >
                    <i class="bi bi-pencil-square"></i>
                </button>
                <button (click)="deleteUser(user)"
                        *ngIf="user.observation_type !== 'blocked'"
                        [disabled]="isLockGroupButton[i]"
                        class="btn btn-danger btn-sm"
                        data-action="deleteMember"
                >
                    <span *ngIf="!isLockGroupButton[i] else refresh">&times;</span>
                </button>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="userList.length" style="padding-left: 5px; padding-bottom: 15px">
        <app-component-pagination
                (page)="setPage($event)"
                [pagination]="pagination"
        ></app-component-pagination>
    </div>
</div>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
